export default __webpack_public_path__ + "b7e01c61351ae1a7a3f1ab6372ceed4e.png";